import { NormalModal, loginSession } from "../common/common.js";

// 非ログイン状態であればログインフォームにリダイレクト
(async () => {
    const isLogin = await loginSession();
    if (!isLogin) {
        window.location.replace('/login/index.html');
    }
})();

var editIndex = 0;


// 読み込み
document.addEventListener('DOMContentLoaded', () => {
    loadCartData();
});

// カート内のセッションを読み込む
async function loadCartData() {
    try {
        const response = await fetch('/system/user/cart/cart-session-fetch.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        });
        const data = await response.json();
        domcreate(data.cart);
        addDeleteEventListeners();
        editEventListener();
    } catch (error) {
        console.error('エラーが発生しました:', error);
    }
}

// 削除ボタンイベントリスナー
function addDeleteEventListeners() {
    document.querySelectorAll('.delete').forEach((btn) => {
        // イベントリスナーの重複を防ぐため、新しいボタンに置き換え
        const newBtn = btn.cloneNode(true);
        btn.replaceWith(newBtn);
        newBtn.addEventListener('click', async () => {
            const item = newBtn.closest('.item');
            if (!item) return;
            const items = Array.from(document.querySelectorAll('.item'));
            const index = items.indexOf(item);

            new NormalModal('カートから削除しますか？', '削除', async () => {
                try {
                    const response = await fetch('/system/user/cart/remove-to-cart.php', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ index: index })
                    });
                    const result = await response.json();
                    if (result.success) {
                        document.getElementById('cart_item_wrap').innerHTML = '';
                        counterMinus();
                        loadCartData();
                    } else {
                        alert('エラーが発生しました。')
                    }
                } catch (error) {
                    console.error('エラーが発生しました:', error);
                }
            });
        });
    });
}

// 削除時ヘッダーカートマークのカウンターを減らす
function counterMinus() {
    let cartItemCount = document.getElementById('cart-btn').querySelector('.count');
    let count = Number(cartItemCount.innerHTML);
    count = count - 1;
    cartItemCount.innerHTML = count;
}

// カート内のDOM組み立て
function domcreate(json) {
    const cartWrap = document.getElementById('cart_item_wrap');
    const itemCount = document.getElementById('item_count');
    const priceDisplay = document.getElementById('price');

    cartWrap.innerHTML = '';

    if (!json) {
        cartWrap.innerHTML = '<p>カートに商品がありません。</p>';
        itemCount.innerText = '0';
        priceDisplay.innerText = '0';
        const paymentTransition = document.querySelectorAll('.payment-transition');
        paymentTransition.forEach((e) => {
            e.remove();
        })
        return;
    }

    const arr = JSON.parse(json);
    itemCount.innerText = arr.length;
    if (arr.length === 0) {
        cartWrap.innerHTML = '<p>カートに商品がありません。</p>';
        itemCount.innerText = '0';
        priceDisplay.innerText = '0';
        const paymentTransition = document.querySelectorAll('.payment-transition');
        paymentTransition.forEach((e) => {
            e.remove();
        })
        return;
    }

    let resultNum = 0;
    let resultPrice = 0;

    arr.forEach(data => {
        resultPrice += data.totalPrice;

        const orderSummary = Object.entries(data.orderSummary)
            .map(([key, value]) => {
                resultNum += value.num;
                return `
                    <div>
                        <span>${key}</span>
                        <span class="num">個数 ${value.num} / </span>
                        <span class="cell-price">単価 ${Number(value.unitPrice).toLocaleString()}円 / </span>
                        <span class="cell-result">合計 ${value.unitResult.toLocaleString()}円</span>
                    </div>
                `;
            })
            .join('');

        const item = document.createElement('div');
        item.classList.add('item');
        item.dataset.pi = data.pi;
        let validDate = '';
        if(data.valid_date){
            const [year, month, day] = data.valid_date.split("-");
            validDate = `<p class="valid_date">${year}年${month}月${day}日の利用に限り有効なチケットです。</p>`;
        }
        item.innerHTML = `
            <p class="location">${data.ticketLocation}</p>
            <p class="item_name">${data.ticketName}</p>${validDate}
            <div class="breakdown">
                <div><span>数量</span></div>
                ${orderSummary}
            </div>
            <div class="option">
                <div class="edit">編集</div>
                <div class="delete">カートから削除</div>
                <p class="item_price">${data.totalPrice.toLocaleString()} 円</p>
            </div>
        `;

        cartWrap.appendChild(item);
    });

    priceDisplay.innerText = resultPrice.toLocaleString();
    itemCount.innerText = resultNum;
}

// 編集ボタン押下時の情報リクエスト
async function editFetch(event) {
    const item = event.target.closest('.item');
    const pi = item.dataset.pi;

    const items = Array.from(document.querySelectorAll('.item'));
    editIndex = items.indexOf(item);

    const editResponse = await fetch('/system/user/cart/edit-fetch.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            pi: pi,
            index: editIndex
        })
    });
    const editObj = await editResponse.json();
    if (editObj['success']) {
        editModal(editObj);
    } else {
        alert('通信が切断されました。')
    }
}

// 編集ボタンイベントリスナー
function editEventListener() {
    const wrapper = document.getElementById('cart_item_wrap');
    const item = wrapper.querySelectorAll('.item');
    item.forEach((elm) => {
        const editBtn = elm.querySelector('.edit');
        editBtn.addEventListener('click', editFetch);
    })
}

// 編集モーダル作成
function editModal(obj) {
    document.getElementById('ticket-name').innerText = obj['ticketName'];
    document.getElementById('location').innerText = obj['location'];
    let form = document.getElementById('order');
    form.innerHTML = '';
    if(obj['inputData']['type'] === 'float'){
        const dateText = document.createElement('p');
        const [year, month, day] = obj['inputData']['valid_date'].split("-");
        dateText.innerText = `${year}年${month}月${day}日のみ利用可能`;
        form.appendChild(dateText);
        const dateInput = document.createElement('input');
        dateInput.type = 'hidden';
        dateInput.id = 'used-date-select';
        dateInput.name = 'used-date-select';
        dateInput.value = obj['inputData']['valid_date'];
        form.appendChild(dateInput);
    }
    form.appendChild(orderListEdit(obj));
    const submit = document.createElement('input');
    submit.type = 'submit';
    submit.value = '変更';
    form.appendChild(submit);
    form.addEventListener('submit', orderEdit);

    const cancel = document.createElement('button');
    cancel.type = 'button';
    cancel.classList.add('white');
    cancel.innerText = 'キャンセル';
    form.appendChild(cancel);
    cancel.addEventListener('click', () => {
        document.getElementById('edit-modal').style.display = 'none';
    })

    document.getElementById('edit-modal').style.display = 'block';
}

// 編集画面価格リスト部分組立
function orderListEdit(obj) {
    const arr = JSON.parse(obj['price']);
    const ul = document.createElement('ul');
    const priceList = JSON.parse(arr['data']);
    priceList.forEach(item => {
        const li = document.createElement('li');
        const label = document.createElement('label');
        const keySpan = document.createElement('span');
        keySpan.className = 'js_keyname';
        keySpan.textContent = item['categoryName'];
        const priceSpan = document.createElement('span');
        priceSpan.className = 'js_price';
        priceSpan.textContent = item['categoryPrice'];
        const yenText = document.createTextNode('円');
        label.appendChild(keySpan);
        label.appendChild(document.createTextNode(' '));
        label.appendChild(priceSpan);
        label.appendChild(yenText);

        const inputWrap = document.createElement('div');
        inputWrap.className = 'input-wrap';
        const text = document.createTextNode('個数：');
        const select = document.createElement('select');
        let options = '<option value="">0</option>';
        for (let i = 1; i <= 9; i++) {
            options += '<option value="' + i + '"';
            if (obj['inputData']['orderSummary'][item['categoryName']]) {
                if (i === obj['inputData']['orderSummary'][item['categoryName']]['num']) {
                    options += ' selected';
                }
            }
            options += '>' + i + '</option>';
        }
        select.innerHTML = options;

        inputWrap.appendChild(text);
        inputWrap.appendChild(select);
        li.appendChild(label);
        li.appendChild(inputWrap);
        ul.appendChild(li);
    });
    return ul;
}

// 編集確定時
async function orderEdit(event) {
    event.preventDefault();
    if (!orderCheck()) {
        notInputModalOpen();
        return false;
    }

    const items = document.querySelectorAll('.item');
    const pi = items[editIndex].dataset.pi;

    const order = orderAcquisition();
    const orderData = {
        pi: pi,
        index: editIndex,
        items: order
    };

    
    const usedDateSelect = document.getElementById('used-date-select');
    if(usedDateSelect){
        orderData.date = usedDateSelect.value;
    }

    const res = await fetch('/system/user/cart/edit.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderData)
    });
    const req = await res.json();
    if (req.success) {
        window.location.reload();
    } else {
        alert('エラーが発生しました。もう一度やり直してください。')
        console.error(req.message);
    }
}

// 編集時、モーダル内のinput属性のvalueを取得し配列で返す
function orderAcquisition() {
    const listTags = document.getElementById('order').querySelectorAll('li');
    let orderArr = [];

    listTags.forEach((item) => {
        const orderNum = item.querySelector('select').value;
        if (orderNum !== '' && !isNaN(orderNum) && Number(orderNum) > 0) {
            orderArr.push(Number(orderNum));
        } else {
            orderArr.push(0);
        }
    });
    return orderArr;
}

// 編集モーダルのヴァリデート
function orderCheck() {
    const cartForm = document.getElementById('order');
    const listTags = cartForm.querySelectorAll('li');

    const flag = Array.from(listTags).some(item => {
        const value = item.querySelector('select').value; // 空白を削除
        return value !== '' && value !== '0'; // 空文字と '0' を除外
    });

    return flag;
}

// 未入力時の警告モーダル
function notInputModalOpen() {
    const modal = document.getElementById('not-input-modal');
    modal.style.display = 'block';
    const curtain = document.createElement('span');
    curtain.className = 'curtain';
    document.querySelector('body').appendChild(curtain);
    modal.querySelector('button').addEventListener('click', notInputModalClose);
}
function notInputModalClose() {
    document.getElementById('not-input-modal').style.display = 'none';
    document.querySelector('.curtain').remove();
}
